import { record } from "../../Images/CallSpaceHeaderSVG";
import { PREVIEW, PREVIEW_SIMULTANEOUS_REC, RECORD_STATE } from "../../constants";
import { getCurrentTimeInSec } from "../../js/helpers/Utils/formats";
import { SingletonSharedData } from "../../js/singletonSharedData";
const sharedData = new SingletonSharedData();

const initialPreviewState ={//
    countRecords: 0,
    dialingMode: 0,
    //--DataRecord--
    isSetPreviewRecord: false,
    record : {},
    data: [],
    previewTime: 0,
    permissionDelete: false,
    previewDiscard: false,
    campaignName: '',
    iconCampaing: '',
    camId: '',
    wrapUpTime:'',
    callKey:'',
    callOutId:'',
    phones:[],
    headers:[],
    initialTimeSec: 0,
    totalPreviewTime:0,
    initPreviewTime:0,
    isTimeAscending: false,
    permissionUpdate: false,
    //-- 
    tempData: [],
    phoneToCall: '',
    isTryingToChangeCamp: false,
    nextCampType: 0,
    isChangeSuccess: false,
    isRunningClock: true,
    dialogTime:undefined,
    isSendProcess: false,
    tempPrevRecord: {},
    selectedPreviewCampaign: null,
    simultaneosRecs: false,
    records:[],
    campaignSelectedDialingRate: 0,
    defaultDialingRate: 0,
    previewType: 0,
    fReplacementJob: 0,
    selectedRecord: {callOutId:0, data:[]},
    messageCode: 0,
    isSomeRecInDialog: false,
    countRecordsDialing: 0,
    countRecordsDialog: 0,
    switchBetweenHold: false,
    ndScheduled: false,
    countRecordsToWrapUp:0,
    switchBetweenWrapUp: false,
    
}

const preview = (state = initialPreviewState, action) => {
   let temp; 

    switch (action.type) {
        case PREVIEW.INCREMENT_DISCARDED:
          return { 
            ...state,
            countRecords: state.countRecords + 1 
          };
        case PREVIEW.SET_PREVIEW_RECORD:
          temp = action.payload.RegsMultiple ? action.payload.PreviewType : 0
          return {
            ...state,
            record: action.payload,
            data: action.payload.DataContact,
            tempData: action.payload.DataContact,
            phoneToCall:action.payload.Phone[0],
            campaignName:action.payload.CampaignName,
            iconCampaing:action.payload.GraphId,
            camId: action.payload.Cam_id,
            wrapUpTime: action.payload.WrapUpTime,
            previewTime: action.payload.PreviewTime,
            initPreviewTime: action.payload.PreviewTime,
            callKey:action.payload.CallKey,
            callOutId: action.payload.CallOut_id,
            phones: action.payload.Phone,
            headers : action.payload.DataHeaders,
            isSetPreviewRecord: true,
            initialTimeSec: getCurrentTimeInSec(),
            permissionDelete: action.payload.PermissionDelete === undefined ? false : action.payload.PermissionDelete,
            previewDiscard :  action.payload.PreviewDiscard  === undefined ? false : action.payload.PreviewDiscard ,
            isTimeAscending:  action.payload.PreviewTime === 0 ? true : false,
            isSendProcess: false,
            simultaneosRecs: action.payload.RegsMultiple,
            //-------simultaneosRecs
            defaultDialingRate: action.payload.DialingRate,
            previewType: temp, // 2 si setting 248 = 0, 1 si setting 248 = 1
            fReplacementJob: temp === 2 ? 0 : 1,
            permissionUpdate: action.payload.PermissionUpdate === undefined ? false : action.payload.PermissionUpdate,
            records: [...state.records,{
                data: action.payload.DataContact,
                tempData: action.payload.DataContact,
                phoneToCall: action.payload.Phone[0],
                campaignName:action.payload.CampaignName,
                iconCampaing:action.payload.GraphId,
                camId: action.payload.Cam_id,
                wrapUpTime: action.payload.WrapUpTime,
                previewTime: action.payload.PreviewTime,
                initPreviewTime: action.payload.PreviewTime,
                callKey:action.payload.CallKey,
                callOutId: action.payload.CallOut_id,
                phones: action.payload.Phone,
                headers : action.payload.DataHeaders,
                initialTimeSec: getCurrentTimeInSec(),
                permissionDelete: action.payload.PermissionDelete == undefined ? false : action.payload.PermissionDelete,
                isTimeAscending:  action.payload.PreviewTime === 0 ? true : false,
                totalPreviewTime: 0,
                logDial:[],
                previewDiscard :  action.payload.PreviewDiscard  !== undefined && action.payload.PreviewDiscard ,
                status: RECORD_STATE.DEFAULT,
                messageStatus: null,
                callId: 0,
                dialogTime:undefined,
                maximumAssignments: -1,
                timeOnDialog: 0,
                itWasSentTimeInPreview:false,
                marks: [],
                volume: {microphoneVol: sharedData.getVolumeMic(), speakerVol:sharedData.getVolumeSpeaker()},
                dispositionData: {alreadyRated: false, exitPreview: undefined},
                calloutMaxTime:0,
                remainingTime:0,
                agentHungUp:false,
                flagLogDial: true,
                permissionUpdate: action.payload.PermissionUpdate === undefined ? false : action.payload.PermissionUpdate,
              }
            ]
          };
        case PREVIEW.UPDATE_PREVIEW_RECORD: 
        (state.records).map(r => {
          if(r.callOutId === action.payload.CallOutId)
            {
              r.data = action.payload.DataContact.slice(0,r.headers.length)
              return r
            }else 
            {
              r.data
            }
          })
          return {
            ...state,
            data: action.payload.IsSave ? (action.payload.DataContact).slice(0,state.headers.length) : state.data,
            selectedRecord: state.records.find(r=> r.callOutId === action.payload.CallOutId)
          };
        case PREVIEW.SET_TEMP_DATA:
          return {
            ...state,
            tempData: action.payload
          };
        case PREVIEW.CLEAN_DATA:
          return{
            ...state,
            isSetPreviewRecord: false,
            record : {},
            data: [],
            previewTime: 0,
            callKey:'',
            callOutId:'',
            phones:[],
            campaignName: '',
            iconCampaing: '',
            camId: '',
            previewDiscard: false,
            permissionDelete:false,
            tempData: [],
            initialTimeSec: 0,
            totalPreviewTime:0,
            initPreviewTime:0,
            dialogTime: undefined,
            isTimeAscending: false,
            simultaneosRecs: false,
            records: [],
            isSomeRecInDialog:false,
            countRecordsDialing: 0,
            countRecordsDialog: 0,
            switchBetweenHold:false,
            ndScheduled: false,
            countRecordsToWrapUp:0,
            switchBetweenWrapUp: false,
            selectedRecord: {callOutId:0, data:[]},
            permissionUpdate: false
          };
        case PREVIEW.SET_PHONE_CALL:
          return{
            ...state,
            phoneToCall: action.payload,
            messageCode: 0

          };
        case PREVIEW.CHANGE_CAMPAIGN_TYPE:
          return{
            ...state,
            isTryingToChangeCamp : action.payload,
            isChangeSuccess: false,
          };
        case PREVIEW.SUCCESSFUL_CHANGE:
          return{
            ...state,
            isChangeSuccess: action.payload.flag,
            nextCampType: action.payload.nextCampType
          }
        case PREVIEW.SET_ISRUNNING_CLOCK:
          return{
            ...state,
            isRunningClock: action.payload
          }
        case PREVIEW.SET_NEWPREVIEW_TIME:
          return{
            ...state,
            previewTime:action.payload
          }
        case PREVIEW.SET_FINAL_TIME:
          return{
            ...state,
            totalPreviewTime: action.payload - state.initialTimeSec + state.totalPreviewTime,
          }
        case PREVIEW.SET_INITIAL_TIME:
          return{
            ...state,
            initialTimeSec: action.payload
          }
        case PREVIEW.SET_DATA_TRANSFER:
          return{
            ...state,
              data: action.payload.ContactData,
              tempData: action.payload.ContactData,
              headers : action.payload.DataHeaders,
              callKey:action.payload.CalKey,
              callOutId: action.payload.CallId,
              camId: action.payload.Id,
          }
        case PREVIEW.SET_DIALOG_TIME:
          return{
            ...state,
            dialogTime: action.payload
          }
        case PREVIEW.SET_DIALINGMODE:
          return{
            ...state,
            dialingMode: action.payload
          }
        case PREVIEW.SET_IS_SEND_PROCESS:
          return{
            ...state,
            isSendProcess: action.payload
          }
        case PREVIEW.SET_TEMP_PREVIEW_RECORD:
            return{
              ...state,
              tempPrevRecord: { 
                camId: action.payload.CamId,
                callOutId: action.payload.CallOutId,
                previewTime:state.totalPreviewTime,
                callId: action.payload.CallId }
            }
        case PREVIEW.SELECTED_PREVIEW_CAMPAIGN:
            return{
              ...state,
              selectedPreviewCampaign: action.payload
            }
        case PREVIEW_SIMULTANEOUS_REC.SET_TOTAL_TIME:
          (state.records).map(r => r.callOutId === action.payload.callOutId ? r.previewTime = action.payload.time - r.initialTimeSec + r.totalPreviewTime : r.previewTime);
          return{
            
            ...state
          }
        case PREVIEW_SIMULTANEOUS_REC.SET_PHONE_TO_CALL:
          (state.records).map(r => r.callOutId === action.payload.callOutId ? r.phoneToCall = action.payload.phone : r.phoneToCall);
          return{
            ...state,
          }
        case PREVIEW_SIMULTANEOUS_REC.REMOVE_RECORD:
          temp=(state.records).filter(r=> r.callOutId !== action.payload)
          return{
            ...state,
            records: temp,
            selectedRecord: state.selectedRecord.callOutId === action.payload ? {callOutId:0, data:[]} : state.selectedRecord,
            isSomeRecInDialog: (temp.map(r=>(r.status === RECORD_STATE.DIALOG || r.status === RECORD_STATE.HOLD || r.status === RECORD_STATE.WRAPUP || r.status === RECORD_STATE.ABANDONED))).includes(true),
            //countRecordsToWrapUp: (temp.filter(r=>(r.status ===  RECORD_STATE.WRAPUP || r.status === RECORD_STATE.ABANDONED || r.status === RECORD_STATE.ALERT))).length
          }
        case PREVIEW_SIMULTANEOUS_REC.SAVE_LOG_DIAL:
          (state.records).map(r => r.callOutId === action.payload.callOutId ? r.logDial = action.payload.logDial : r.logDial);
          return{
            ...state,
          }
        case PREVIEW_SIMULTANEOUS_REC.CHANGE_RECORD_STATE:
          const temporalRecords = (state.records).map(r => {
            if(r.callOutId === action.payload.callOutId){
              return {
                ...r,
                status: action.payload.status,
                messageStatus: action.payload.messageStatus ? action.payload.messageStatus : r.messageStatus,
                remainingTime: action.payload.status === RECORD_STATE.DIALING ? action.payload.remainingTime : r.remainingTime,
                waitingWrapUp: (action.payload.status === RECORD_STATE.WAITING_WRAPUP) ? true : false
              }
            }
            return r
          });

          const temporalRecord = state.selectedRecord.callOutId === action.payload.callOutId ? action.payload : state.selectedRecord;
          const tempRecordsDialing = (temporalRecords.filter(r=>r.status === RECORD_STATE.DIALING)).length
          const tempRecordsDialog = (temporalRecords.filter(r=>r.status === RECORD_STATE.DIALOG)).length
          const tempRecordsHold =temporalRecords.filter(r=>(r.status === RECORD_STATE.HOLD)).length
          const tempRecordsToWrapUp = (temporalRecords.filter(r=>(r.status ===  RECORD_STATE.WRAPUP || r.status === RECORD_STATE.ABANDONED || r.status === RECORD_STATE.ALERT))).length
          return{
            ...state,
            records: temporalRecords,
            isSomeRecInDialog: (temporalRecords.map(r=>(r.status === RECORD_STATE.DIALOG || r.status === RECORD_STATE.HOLD || r.status === RECORD_STATE.WRAPUP || r.status === RECORD_STATE.ABANDONED))).includes(true),
            countRecordsDialing: tempRecordsDialing,
            countRecordsDialog: tempRecordsDialog,
            selectedRecord: {...state.selectedRecord,  ...temporalRecord },
            switchBetweenHold:( tempRecordsDialog === 0 && tempRecordsHold > 0) ? true : false,
           // countRecordsToWrapUp: tempRecordsToWrapUp,
            switchBetweenWrapUp: tempRecordsDialog === 0 && tempRecordsHold === 0 && tempRecordsToWrapUp > 0
          }
        case PREVIEW_SIMULTANEOUS_REC.SET_INITIAL_DIALOG_TIME:
          const tempRecords = (state.records).map(r => {
            if(r.callOutId === action.payload.callOutId){
              return {
                ...r,
                timeOnDialog: r.timeOnDialog === 0 && action.payload.timeOnDialog ? action.payload.timeOnDialog : r.timeOnDialog
              }
            }
            return r
          });

          const tempRecord = state.selectedRecord.callOutId === action.payload.callOutId ? action.payload : state.selectedRecord;
          
          return{
            ...state,
            records: tempRecords,
            selectedRecord: {...state.selectedRecord, ...tempRecord}
          }
        case PREVIEW_SIMULTANEOUS_REC.SELECTED_RECORD:
        return{
          ...state,
          selectedRecord: state.records.find(r=> r.callOutId === action.payload)
        }
        case PREVIEW_SIMULTANEOUS_REC.MESSAGE_STATUS:
        (state.records).map(r => r.callOutId === action.payload.callOutId ? r.messageStatus = action.payload.messageStatus : r.messageStatus);
        return{
          ...state,
        }
        case PREVIEW_SIMULTANEOUS_REC.SET_INITIAL_TIMESEC:
          (state.records).map(r => r.callOutId === action.payload.callOutId ? r.initialTimeSec = action.payload.seconds : r.initialTimeSec);
          return{
            ...state
          }
        case PREVIEW_SIMULTANEOUS_REC.RESET_RECORD:
          const selectedRecordReset = {
            ...state.records.find(r=>r.callOutId === action.payload), 
            previewTime: state.selectedRecord.initPreviewTime, 
            status: RECORD_STATE.DEFAULT,
            messageStatus:null,
            marks:[],
            itWasSentTimeInPreview: false,
            timeOnDialog:0,
            dialogTime:undefined,
            volume: {microphoneVol: sharedData.getVolumeMic(), speakerVol:sharedData.getVolumeSpeaker()},
            dispositionData:{alreadyRated: false, exitPreview:undefined},
            isTimeAscending: state.selectedRecord.initPreviewTime === 0 ? true : false,
            remainingTime:0,
            logDial:[],
            agentHungUp:false,
            initialTimeSec: getCurrentTimeInSec(),
            flagLogDial: true
          }
          const tRecords = state.records.map(r => r.callOutId === action.payload ? selectedRecordReset : r);
          return{
            ...state,
            records: tRecords ,
            selectedRecord: selectedRecordReset,
            isSomeRecInDialog: (tRecords.map(r=>(r.status === RECORD_STATE.DIALOG || r.status === RECORD_STATE.HOLD || r.status === RECORD_STATE.WRAPUP || r.status === RECORD_STATE.ABANDONED))).includes(true),
            //countRecordsToWrapUp: (tRecords.filter(r=>(r.status ===  RECORD_STATE.WRAPUP || r.status === RECORD_STATE.ABANDONED || r.status === RECORD_STATE.ALERT))).length

          }
        case PREVIEW_SIMULTANEOUS_REC.SET_CALL_ID:
          (state.records).map(r => r.callOutId === action.payload.callOutId ? (r.callId = action.payload.callId, r.calloutMaxTime= action.payload.calloutMaxTime ): (r.callId, r.calloutMaxTime));
          return{
            ...state
          }
        case PREVIEW_SIMULTANEOUS_REC.SET_DIALOG_TIME:
          (state.records).map(r => r.callOutId === action.payload.callOutId ? r.dialogTime = action.payload.dialogTime : r.dialogTime);
          return{
            ...state
          }
        case PREVIEW_SIMULTANEOUS_REC.SET_MAXIMUM_ASSIGNMENTS:
          (state.records).map(r => r.callOutId === action.payload.callOutId ? r.maximumAssignments = action.payload.maximumAssignments : r.maximumAssignments);
          return {
            ...state,
            selectedRecord: state.records.find(r=>r.callOutId === state.selectedRecord.callOutId) || state.selectedRecord
          }
        case PREVIEW_SIMULTANEOUS_REC.SET_IT_WAS_SENT_TIME:
          (state.records).map(r => r.callOutId === action.payload.callOutId ? r.itWasSentTimeInPreview = action.payload.itWasSent : state.itWasSentTimeInPreview);
          return {
            ...state
          }
        case PREVIEW_SIMULTANEOUS_REC.SET_VOLUME:
          (state.records).map(r => r.callOutId === action.payload.callOutId ? r.volume = {microphoneVol: action.payload.micVol, speakerVol:action.payload.speakVol}: r.volume);
          return{
            ...state
          }
        case PREVIEW_SIMULTANEOUS_REC.SET_DISPOSITION_DATA:
          (state.records).map(r => r.callOutId === action.payload.callOutId ? r.dispositionData = {alreadyRated: action.payload.alreadyRated, exitPreview:action.payload.exitPreview}: r.dispositionData);
          return{
            ...state,
            selectedRecord: state.records.find(r=>r.callOutId === state.selectedRecord.callOutId) || state.selectedRecord
          }
        case PREVIEW_SIMULTANEOUS_REC.SET_ND_SCHEDULED:
          return{
            ...state,
            ndScheduled:true
          }
        case PREVIEW_SIMULTANEOUS_REC.SET_FLAG_LOGDIAL:
          const tempRecs =(state.records).map(r => {
            if(r.callOutId === action.payload)
            {
              r.flagLogDial = false;
            }
            return r;
          });
          return{
            ...state,
            records: tempRecs,
            selectedRecord: tempRecs.find(r=>r.callOutId === action.payload)
          }
        default:
          return state;
      }
}

export default preview


// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_preview.js